import { api, generateCRUDInterface } from "aldoo-ra/API"
//construct the endpoint
const crudAPI = api("crud")

//Given the crud API, generate the CRUD interface
const crud = generateCRUDInterface(crudAPI, "ProductLicenseModel")

//override the get method to add default filtering and sorting
crud.Get = async (get) => {
  // Remove the deleted filter that generateCRUDInterface adds
  const { deleted, ...matchWithoutDeleted } = (get.match || {})
  
  get = {
    ...get,
    model: "ProductLicenseModel",
    //sort by primary first, then by name
    sort: { primary: -1, name: 1 },
    //use match without deleted field since ProductLicenseModel doesn't use soft delete
    match: matchWithoutDeleted,
  }
  return await crudAPI({ get })
}

export default crud